const navigation = [
  {
    id: 1,
    name: "Home",
    url: "/ess/home",
    img: "/img/home-w.svg",
    hideSide: true,
    children: [],
  },
  {
    id: 99,
    url: "/ess/change-password",
    name: "changePassword",
    img: "img/password.svg",
    hide: true,
    children: [
      {
        id: 130,
        name: "Change Password",
        url: "",
        img: "",
        hide: true,
      },
    ],
    // hide: true,
    // showSub: true
  },
  // {
  //   id: 2,
  //   name: "Dashboard",
  //   url: "/ess/dashboard",
  //   img: "/img/dashboard-w.svg",
  //   children: []
  // },
  {
    id: 3,
    name: "HRM",
    url: "/ess/hrm",
    img: "/img/hrm.svg",
    children: [
      {
        id: 8,
        name: "Exemption",
        img: "/img/exemption-w.svg",
        url: "/ess/hrm/exemption",
      },
      {
        id: 9,
        name: "Leave",
        img: "/img/leave-w.svg",
        url: "/ess/hrm/leave",
      },
      {
        id: 16,
        name: "Reports",
        img: "/img/reports.svg",
        url: "/ess/hrm/reports",
      },
      ...(process.env.NODE_ENV !== "production"
        ? [
            {
              id: 15,
              name: "Appraisal",
              img: "/img/appraisal-w.svg",
              url: "/ess/hrm/appraisal",
            },
          ]
        : []),
    ],
  },
  {
    id: 4,
    name: "Attendance",
    url: "/ess/attendance",
    img: "/img/attendance.svg",
    children: [
      {
        id: 100,
        name: "Calendar",
        url: "/ess/attendance/calendar",
        img: "/img/calendar-w.svg",
      },

      {
        id: 132,
        name: "Mobile Clocks",
        url: "/ess/attendance/mobile-clocks",
        img: "/img/mobile-clocks.svg",
      },
      {
        id: 102,
        name: "Overtime",
        url: "/ess/attendance/overtime",
        img: "/img/overtime.svg",
      },
      {
        id: 101,
        name: "Reports",
        url: "/ess/attendance/reports",
        img: "/img/reports.svg",
      },
    ],
  },
  {
    id: 5,
    name: "Payroll",
    url: "/ess/payroll",
    img: "/img/payroll.svg",
    children: [
      {
        id: 40,
        name: "Dashboard",
        url: "/ess/payroll/dashboard",
        img: "/img/dashboard-w.svg",
      },
      {
        id: 41,
        name: "Loan",
        url: "/ess/payroll/loan",
        img: "/img/loan.png",
      },
      {
        id: 42,
        name: "Payslip",
        url: "/ess/payroll/payslip",
        img: "/img/pay-package.svg",
      },
      {
        id: 44,
        name: "Reports",
        url: "/ess/payroll/report",
        img: "/img/reports.svg",
      },
    ],
  },
  {
    id: 9,
    name: "Performance",
    url: "/ess/performance",
    img: "/img/performance.svg",
    children: [
      {
        id: 91,
        name: "Dashboard",
        url: "/ess/performance/dashboard",
        img: "/img/dashboard-w.svg",
      },
      {
        id: 92,
        name: "Performance Appraisal",
        url: "/ess/performance/appraisal",
        img: "/img/appraisal.svg",
      },
      {
        id: 93,
        name: "Feedback",
        url: "/ess/performance/feedback",
        img: "/img/feedback-w.svg",
      },
      {
        id: 94,
        name: "Task Management",
        url: "/ess/performance/task-management",
        img: "/img/task.svg",
      },
      {
        id: 95,
        name: "Training",
        url: "/ess/performance/training",
        img: "/img/training.svg",
      },
    ],
  },
  {
    id: 6,
    name: "Canteen",
    url: "/ess/canteen",
    img: "/img/canteen.svg",
    children: [],
  },
  {
    id: 7,
    name: "Support",
    url: "/ess/support",
    img: "/img/leave-w.svg",
    hide: true,
    children: [
      {
        id: 120,
        name: "",
        url: "",
        img: "",
      },
    ],
  },
  {
    id: 12,
    name: "Employees",
    url: "/ess/profile",
    img: "",
    hide: true,
    children: [
      {
        id: 600,
        name: "Employees",
        url: "",
        img: "",
        hide: true,
      },
    ],
  },

  {
    id: 8,
    name: "Activity History",
    url: "/ess/activity-history",
    img: "/img/time-history.svg",
    children: [],
  },
];

export default navigation;
